import { useConfig } from 'components/ui'

function useThemeClass() {
    const { primaryColorLevel } = useConfig()
    const color = `blue-${primaryColorLevel}`

    return {
        ringTheme: `ring-${color}`,
        borderTheme: `border-${color}`,
        bgTheme: `bg-${color}`,
        textTheme: `text-${color}`,
    }
}

export default useThemeClass
